import React from 'react'
import List from './List'
import {hubblerReviewData} from '../data/webData';
import AliceCarousel from 'react-alice-carousel';


const responsive = {
    0: {
        items: 1
    },
    320: {
        items: 1
    },
    550:{
        items: 2
    },
    768: {
        items: 2
    },
    1024: {
        items: 2
    },
    1260: {
        items: 4
    },
    1460: {
        items: 4
    },
    3000:{
        items:4
    }
};
export default class ContentSilder extends React.Component{
    galleryItems() {
        return (
            hubblerReviewData.map((item, i) => (
                <li key={i} className={'slide-item'}>
                    <p className={'para'}>{item.description}</p>
                    <div className={'name'}>- {item.name}</div>
                </li>
            ))
        )
    }
    render(){
        return <div className={'content-silder'}>
            <div className={'review-slider'}>
                <AliceCarousel
                    items={this.galleryItems()}
                    duration={400}
                    responsive={responsive}
                    fadeOutAnimation={true}
                    mouseDragEnabled={true}
                    autoPlay={false}
                    startIndex = {0}
                    playButtonEnabled={false}
                    autoPlayInterval={5000}
                    autoPlayDirection="ltr"
                />
            </div>

{/*
            <List items={hubblerReviewData} listItem={ListItem} className={'review-slider'}/>
*/}
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/ContentSilder.js